import auth from './auth';
import toThousands from './toThousands';
export default {
  install (Vue) {
    Vue.directive('auth', auth);
    Vue.directive('toThousands', toThousands);
  },
};
